/* 
*  Removes the classes associated with the conversion animation
*  that otherwise is included from the WP API.
*/
export const addImgSrc = (rawHtmlString) => {
  return rawHtmlString.replace(/data-src/g, () => 'src')
}

/*
* Redirects blogs to current blogs instead of blog.handiscover.com 
* and removed links that does not link to a http-link. 
*/
export const updateLinksInText = (text) => {
  text = text
    .replace(/href="(?!http).*?"/g, () => 'style="cursor: default"')
    .replace(/href="https:\/\/blog\.handiscover\.com\/content\/tips-articles\//g, () => 'href="/content/')
    .replace(/href="https:\/\/blog\.handiscover\.com\/content\/destinations\/uk\//g, () => 'href="/content/')
    .replace(/href="https:\/\/blog\.handiscover\.com\/content\/wp-content.*?"/g, () => '')

  return text
}
